// extracted by mini-css-extract-plugin
export default {"FAQCard":"FAQCard_FAQCard__waqx4","FAQCard__text":"FAQCard_FAQCard__text__khZZH","normal":"FAQCard_normal__ovfce","large":"FAQCard_large__eQrrf","grey":"FAQCard_grey__-6GCp"};